<template>
  <transition name="slide-fade"
    mode="out-in" v-if="canAccessPage">
    <router-view></router-view>
  </transition>
</template>
<script>
import { generateComputed } from '@/common/functions/roles-computed-generator';

export default {
  name: 'Workflow',
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast('Acesso negado');
    },
  },
  computed: {
    ...generateComputed('Fluxo', [
      'canAccessPage',
    ]),
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
